import request from '@/router/axios';

export const getDefaultProject = () => {
  return request({
    url: '/api/jida-system/param/default-project',
    method: 'get',
    params:{}
  })
}
